import React from "react";
import PropTypes from "prop-types";

import * as types from "../../../constants/ComponentConstants";

import Form from "../../common/Form";
import Section from "../../common/Section";
import TextInput from "../../common/TextInput";
import DateInput from "../../common/DateInput";
import SelectInput from "../../common/SelectInput";
import Fieldset from "../../common/Fieldset";
import Row from "../../common/Row";

const IdentificatieForm = (props) => {
    const {
        model,
        originalModel,
        onChange,
        onSave,
        errors,
        validationMessageType,
        disabled,
        statuten,
        rechtsvormen,
        datumOprichtingHasFocus
    } = props;

    return (
        <Section title="Identificatiegegevens" color={types.COLOR_ORANGE}>
            <Form name="identificatie"
                headerVisible={false}
                isNotRequired
                rightButtonLabel="Bewaar"
                onRightButtonClick={onSave}
                rightButtonDisabled={disabled}
                color
            >
                <Fieldset>
                    <Row>
                        <TextInput
                            name="id"
                            label="PO-ID"
                            value={model.id}
                            disabled
                            size={6}
                        />
                        <TextInput
                            name="vCode"
                            label="V-Code"
                            value={model.vCode}
                            disabled={true}
                            size={6}
                        />
                    </Row>
                    <Row>
                        <DateInput
                            name="oprichtDatum"
                            label="Datum oprichting"
                            value={model.oprichtDatum}
                            originalValue={originalModel.oprichtDatum}
                            onChange={onChange}
                            disabled={disabled}
                            validationMessage={errors ? errors['oprichtDatum'] : ""}
                            validationMessageType={validationMessageType}
                            size={6}
                            hasFocus={datumOprichtingHasFocus}
                        />
                        <DateInput
                            name="stopDatum"
                            label="Datum stopzetting"
                            value={model.stopDatum}
                            originalValue={originalModel.stopDatum}
                            onChange={onChange}
                            disabled={disabled}
                            validationMessage={errors ? errors['stopDatum'] : ""}
                            validationMessageType={validationMessageType}
                            size={6}
                            optional
                        />
                    </Row>
                    <Row>
                        <TextInput
                            name="ondernemingsnummer"
                            label="Ondernemingsnummer"
                            value={model.ondernemingsnummer}
                            originalValue={originalModel.ondernemingsnummer}
                            onChange={onChange}
                            disabled={disabled}
                            validationMessage={errors ? errors['ondernemingsnummer'] : ""}
                            validationMessageType={validationMessageType}
                            size={6}
                            optional
                            isOndernemingsnummer
                        />

                        <SelectInput
                            name="statuut"
                            label="Statuut"
                            value={model.statuut}
                            originalValue={originalModel.statuut}
                            size={6}
                            items={statuten}
                            onChange={onChange}
                            disabled={disabled}
                            validationMessage={errors ? errors["statuut"] : ""}
                            validationMessageType={validationMessageType} />
                    </Row>
                    <Row>
                        <SelectInput
                            name="rechtsvorm"
                            label="Rechtsvorm"
                            value={model.rechtsvorm}
                            originalValue={originalModel.rechtsvorm}
                            size={6}
                            items={rechtsvormen}
                            onChange={onChange}
                            disabled={disabled}
                            validationMessage={errors ? errors["rechtsvorm"] : ""}
                            validationMessageType={validationMessageType} />
                    </Row>
                </Fieldset>
            </Form>
        </Section>);
};

IdentificatieForm.defaultProps = {
    statuten: [],
    rechtsvormen: []
};

IdentificatieForm.propTypes = {
    model: PropTypes.object,
    originalModel: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    errors: PropTypes.object,
    validationMessageType: PropTypes.string,
    disabled: PropTypes.bool,
    statuten: PropTypes.array.isRequired,
    rechtsvormen: PropTypes.array.isRequired,
    datumOprichtingHasFocus: PropTypes.bool
};

export default IdentificatieForm;